"use client"

import dynamic from 'next/dynamic';

export const ListingsMapList = dynamic(
  () =>
    import('@/components/listingsMap/Map/Map').then((i) => i.ListingsMapList),
  {
    ssr: false,
    loading: () => null,
  }
);
